import React from 'react';
import { Progress, Card, Typography } from 'antd';
import styled from 'styled-components';
import { useAttributionQuota } from '../Navbar/AttributionQuotaIndicator';

const { Title, Text } = Typography;

const QuotaCard = styled(Card)`
  margin-top: 20px;
`;

const ProgressWrapper = styled.div`
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  margin: 12px 0;
`;

// Format number to be more readable (e.g., 1k, 10k, etc.)
const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${Math.floor(num / 100000) / 10}M`;
  }
  if (num >= 1000) {
    return `${Math.floor(num / 100) / 10}k`;
  }
  return num.toString();
};

export const QuotaSection: React.FC = () => {
  const { data: attributionQuota, isLoading, error } = useAttributionQuota();

  if (isLoading) {
    return (
      <QuotaCard title="Attribution Quota Usage">
        <div>Loading...</div>
      </QuotaCard>
    );
  }

  if (error || !attributionQuota) {
    return null;
  }

  return (
    <QuotaCard title="Attribution Quota Usage">
      <Title level={5}>Monthly Attribution Usage</Title>
      <Text>
        {formatNumber(attributionQuota.used)} of{' '}
        {formatNumber(attributionQuota.total)} attributions used (
        {attributionQuota.percentage}%)
      </Text>
      <ProgressWrapper>
        <Progress
          percent={attributionQuota.percentage}
          status={attributionQuota.percentage >= 90 ? 'exception' : 'normal'}
          strokeColor={{
            '0%': '#52c41a',
            '50%': '#faad14',
            '100%': '#f5222d',
          }}
        />
      </ProgressWrapper>
      <Text type="secondary">
        Your quota resets at the beginning of each month.
        {attributionQuota.percentage >= 75 && (
          <Text type="warning">
            {' '}
            You are approaching your monthly limit. Consider upgrading your plan
            for more attributions.
          </Text>
        )}
      </Text>
    </QuotaCard>
  );
};
